import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  message?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className,
  message,
  fullScreen = false
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const spinner = (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="text-center">
        <div
          className={cn(
            'animate-spin rounded-full border-t-2 border-b-2 border-primary mx-auto',
            sizeClasses[size]
          )}
        />
        {message && (
          <p className="text-muted-foreground mt-2 text-sm">{message}</p>
        )}
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

// Convenience components for common use cases
export const PageLoadingSpinner: React.FC<{ message?: string }> = ({ message }) => (
  <LoadingSpinner
    size="lg"
    message={message || 'Loading...'}
    className="min-h-screen"
  />
);

export const SectionLoadingSpinner: React.FC<{ message?: string }> = ({ message }) => (
  <LoadingSpinner
    size="md"
    message={message || 'Loading...'}
    className="py-8"
  />
);

export const InlineLoadingSpinner: React.FC<{ message?: string }> = ({ message }) => (
  <LoadingSpinner
    size="sm"
    message={message}
    className="py-2"
  />
);
